module.exports = __webpack_public_path__ + "2646393393169b8397a8b1d65284dd08.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/franchises/coh_image_mobile.jpg
// module id = 134
// module chunks = 0